/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseIcon16Solid = forwardRef('MediaUiAPauseIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7 3a1 1 0 0 0-2 0v10a1 1 0 1 0 2 0V3Z" }),
        React.createElement("path", { d: "M11 3a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V3Z" })));
});
